import { Stack } from "@mui/material";

import { LoadingButton } from "../../redesign/components/LoadingButton";

interface ShiftTimeProposalCardActionsProps {
  isUpdateShiftTimeProposalLoading: boolean;
  onAccept?: () => Promise<void>;
  onDecline?: () => Promise<void>;
}

export function ShiftTimeProposalCardActions({
  isUpdateShiftTimeProposalLoading,
  onAccept,
  onDecline,
}: ShiftTimeProposalCardActionsProps) {
  return (
    <Stack direction="row" justifyContent="space-between" spacing={3} width="100%">
      <LoadingButton
        fullWidth
        isLoading={isUpdateShiftTimeProposalLoading}
        disabled={isUpdateShiftTimeProposalLoading}
        variant="outlined"
        startIconType="close"
        onClick={onDecline}
      >
        Decline
      </LoadingButton>

      <LoadingButton
        fullWidth
        isLoading={isUpdateShiftTimeProposalLoading}
        disabled={isUpdateShiftTimeProposalLoading}
        variant="contained"
        startIconType="checkmark"
        onClick={onAccept}
      >
        Accept
      </LoadingButton>
    </Stack>
  );
}
